export enum LogMetricState {
    Start = "Start",
    End = "End",
    Standalone = "Standalone"
}